/* eslint-disable no-template-curly-in-string */
import React, { Component, Fragment } from 'react';
import InputField from '../../global/InputField';
import CelaneseAPI from '../../../services';
import { Combobox } from 'react-widgets';
import config, { utils } from '../../../config';
import PlugwrapThickness from '../../PlugwrapThickness';
import { Modal, Button, message } from 'antd';
import PropTypes from 'prop-types';
import 'react-widgets/dist/css/react-widgets.css';
import '../SingleFilter/singleFilter.css';
import { connect } from 'react-redux';
import Convert from '../../../convert';
import { getCarbonFiltersData } from './../../../actions/index';
import Translation from '../../../Translation';

/**
 * Class for Combined Filter.
 *
 * @class CombinedFilter
 * @extends {Component}
 */
class CombinedFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pref: {
                weight: ['g/100', 'mg', 'g'],
                lowpdlim: ['mm H₂O', 'pa'],
                pz: ['% Dry Basis', '% Wet Basis'],
                pivmaxlim: ['Tow Weight', 'Wet Weight']
            },
            loading: false,
            combinedFilterData: [],
            combFilterSectionData: {},
            isFetchingFilters: false,
            dualFilterName: '',
            filter1Data: null,
            filter2Data: null,
            tipsRod: 2,
            plugwrapThickness: 0.039,
            smoke: 0,
            tar: 0,
            nicotine: 0,
            eugenol: 0.00,
            totalFilterLength: 0,
            totalFilterWeight: 0,
            totalFilterEPD: 0,
            whiteFilterWgt: 0,
            whiteFilterEPD: 0,
            towOnlyFilterWgt: 0,
            carbonOnlyFilterWgt: 0.00,
            carbonOnlyFilterEPD: 0.00,
            totalTipLength: 0,
            totalTipWeight: 0,
            totalTipEPD: 0,
            whiteTipWgt: 0,
            whiteTipEPD: 0,
            towOnlyTipWgt: 0,
            carbonOnlyTipWgt: 0.00,
            carbonOnlyTipEPD: 0.00,
            isPlugwrapVisible: false,
            isPaperGlue: false,
            totalTipCirc: 0,
            totalTipDiam: 0,
            combinedTipCirc: 0,
            combinedTipDiam: 0,
            preferences: this.props.preferences,
            id: null,
            saveCombWithoutFilter: false,
            sharedByName: ''
        };

        this.handleTipsBlur = this.handleTipsBlur.bind(this);
    }
    /**
     *success function displays success message when combined filter is created/updated successfully
     *
     * @memberof CombinedFilter
     */
    success = (msg) => {
        message.success(msg, 2);
    };
    /**
     * error function displays error message when combined filter is not created/updated successfully
     *
     * @memberof CombinedFilter
     */
    error = () => {
        message.error(<Translation labelName="msg_some_issue" defaultText="There was some issue." />, 2);
    };
    /**
     * warning function displays message when required fields are empty
     *
     * @memberof CombinedFilter
     */
    warning = () => {
        message.warning(<Translation labelName="msg_fields_empty" defaultText="The Required fields are empty" />, 2);
    };
    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        });
    }
    /**
     * handlePlugwrapCancel function closes the plugwrap window
     *
     * @memberof CombinedFilter
     */
    handlePlugwrapCancel = () => {
        this.setState({
            isPlugwrapVisible: false
        });
    }
    /**
     * showPlugwrapModal function opens the plugwrap window
     *
     * @memberof CombinedFilter
     */
    showPlugwrapModal = () => {
        this.setState({
            isPlugwrapVisible: true
        });
    }
    /**
     * updatePlugwrapValue populates the form with selected plugwrap value
     *
     * @param {string} data
     * @memberof CombinedFilter
     */
    updatePlugwrapValue = (data) => {
        this.setState({
            plugwrapThickness: data
        });
    }

    addFilterParam(param, filter1, filter2) {
        return (parseFloat(filter1[param]) + parseFloat(filter2[param])).toFixed(2);
    }

    calculateCombiFilter() {
        if (!(this.state.filter1Data && this.state.filter2Data)) {
            return;
        }

        if (!(this.state.filter1Data.tipepd && this.state.filter2Data.tipepd)) {
            return;
        }

        let filter1 = this.state.filter1Data;
        let filter2 = this.state.filter2Data;
        let obj = {};
        obj.totalTipLength = this.addFilterParam('tiplen', filter1, filter2);
        obj.totalTipWeight = this.addFilterParam('tipwt', filter1, filter2);
        obj.totalTipEPD = this.addFilterParam('tipepd', filter1, filter2);
        obj.whiteTipWgt = this.addFilterParam('tiptgtwt', filter1, filter2);
        obj.whiteTipEPD = this.addFilterParam('tiptgtpd', filter1, filter2);
        obj.towOnlyTipWgt = this.addFilterParam('tiptowowt', filter1, filter2);
        obj.tippzwt = this.addFilterParam('tippzwt', filter1, filter2);
        obj.tiprodpgwt = this.addFilterParam('tiprodpgwt', filter1, filter2);
        obj.tipdrywt = this.addFilterParam('tipdrywt', filter1, filter2);
        obj.tiptgtpd = this.addFilterParam('tiptgtpd', filter1, filter2);
        obj.tippzpd = this.addFilterParam('tippzpd', filter1, filter2);
        obj.tipgphtgtwt = this.addFilterParam('tipgphtgtwt', filter1, filter2);
        obj.tipgphtgtpd = this.addFilterParam('tipgphtgtpd', filter1, filter2);
        obj.tipCapsuletgtwt = this.addFilterParam('tipCapsuletgtwt', filter1, filter2);
        obj.tipCapsuletgtpd = this.addFilterParam('tipCapsuletgtpd', filter1, filter2);
        obj.tipCarbontgtwt = this.addFilterParam('tipCarbontgtwt', filter1, filter2);
        obj.tipCarbontgtpd = this.addFilterParam('tipCarbontgtpd', filter1, filter2);
        // obj.tipfilterwt = this.addFilterParam('tipfilterwt', filter1, filter2);
        // obj.tipfilterpd = this.addFilterParam('tipfilterpd', filter1, filter2);
        obj.pz = filter1.pz > 0 || filter2.pz > 0;
        obj.tipfilterwt = parseFloat(obj.tipgphtgtwt) + parseFloat(obj.tipCapsuletgtwt) + parseFloat(obj.tipCarbontgtwt);
        obj.tipfilterpd = parseFloat(obj.tipgphtgtpd) + parseFloat(obj.tipCapsuletgtpd) + parseFloat(obj.tipCarbontgtpd);

        obj.totalFilterLength = this.combinedTip(obj.totalTipLength);
        obj.totalFilterWeight = this.combinedTip(obj.totalTipWeight);
        obj.totalFilterEPD = this.combinedTip(obj.totalTipEPD);
        obj.whiteFilterWgt = this.combinedTip(obj.whiteTipWgt);
        obj.whiteFilterEPD = this.combinedTip(obj.whiteTipEPD);
        obj.towOnlyFilterWgt = this.combinedTip(obj.towOnlyTipWgt);
        obj.carbonOnlyFilterWgt = this.combinedTip(obj.carbonOnlyTipWgt);
        obj.carbonOnlyFilterEPD = this.combinedTip(obj.carbonOnlyTipEPD);
        obj.capsuleOnlyFilterWgt = this.combinedTip(obj.capsuleOnlyTipWgt);
        obj.capsuleOnlyFilterEPD = this.combinedTip(obj.capsuleOnlyTipEPD);
        obj.pzwt = this.combinedTip(obj.tippzwt);
        obj.rodpgwt = this.combinedTip(obj.tiprodpgwt);
        obj.drywt = this.combinedTip(obj.tipdrywt);
        obj.tgtpd = this.combinedTip(obj.tiptgtpd);
        obj.pzpd = this.combinedTip(obj.tippzpd);
        obj.gphtgtwt = this.combinedTip(obj.tipgphtgtwt);
        obj.gphtgtpd = this.combinedTip(obj.tipgphtgtpd);
        obj.capsuletgtwt = this.combinedTip(obj.tipCapsuletgtwt);
        obj.capsuletgtpd = this.combinedTip(obj.tipCapsuletgtpd);
        obj.carbontgtwt = this.combinedTip(obj.tipCarbontgtwt);
        obj.carbontgtpd = this.combinedTip(obj.tipCarbontgtpd);
        obj.filterwt = this.combinedTip(obj.tipfilterwt);
        obj.filterpd = this.combinedTip(obj.tipfilterpd);


        obj.isPaperGlue = filter1.isPaperGlue || filter2.isPaperGlue;
        obj.showCarbon = filter1.hasCload || filter2.hasCload;
        obj.showCapsule = filter1.hasCapsule || filter2.hasCapsule;

        obj.combinedTipCirc = Math.max(parseFloat(filter1.tipcirc), parseFloat(filter2.tipcirc))
        obj.combinedTipDiam = Convert.toDiameter(obj.combinedTipCirc);
        obj.totalTipDiam = parseFloat(obj.combinedTipDiam) + 2 * parseFloat(this.state.plugwrapThickness).toFixed(2);
        obj.totalTipCirc = Convert.toCircumference(obj.totalTipDiam);

        obj.smoke = parseFloat(filter1.sre + (1 - filter1.sre / 100) * filter2.sre).toFixed(2);
        obj.tar = parseFloat(filter1.tre + (1 - filter1.tre / 100) * filter2.tre).toFixed(2);
        obj.nicotine = parseFloat(filter1.nre + (1 - filter1.nre / 100) * filter2.nre).toFixed(2);
        obj.eugenol = parseFloat(filter1.ere + (1 - filter1.ere / 100) * filter2.ere).toFixed(2) || 0;
        obj.isFetchingFilters = false;

        if (this.props.afterCalculate) {
            this.props.afterCalculate({
                sre: obj.smoke,
                tre: obj.tar,
                nre: obj.nicotine,
                ere: obj.eugenol,
                tipcirc: obj.combinedTipCirc,
                tipepd: obj.totalTipEPD
            });
        }


        this.setState(obj);

    }

    handleTipsBlur(event) {
        event.preventDefault();
        this.calculateCombiFilter();
    }

    combinedTip(val) {
        return parseFloat(parseFloat(val) * parseInt(this.state.tipsRod, 10)).toFixed(2);
    }

    componentWillMount() {
        this.assignData(this.props);
    }
    /**
     * assignData function gets combinedfilterData from redux/store
     *
     * @param {*} nextProps
     * @memberof CombinedFilter
     */
    assignData(nextProps) {
        if (nextProps.carbonFiltersData) {
            this.setState({
                combinedFilterData: nextProps.carbonFiltersData
            });

        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.dualFilterId && nextProps.dualFilterName && this.state.id !== nextProps.dualFilterId) {
            this.setState({
                dualFilterName: nextProps.dualFilterName,
                id: nextProps.dualFilterId
            }, function () {
                this.handleFilter();
            })
        }
        if (this.state.combinedFilterData !== nextProps.carbonFiltersData && this.state.id === nextProps.dualFilterId) {
            const matchedIndex = nextProps.carbonFiltersData.findIndex((val) => {
                return val.id === nextProps.dualFilterId
            });
            if (matchedIndex === -1) {
                this.setState({
                    dualFilterName: '',
                    id: null
                }, function () {
                    this.getCigaretteByName();
                })
            }
        }
        if (this.props.combFilterSectionData !== nextProps.combFilterSectionData) {
            if (nextProps.combFilterSectionData.isShared) {
                this.setState({
                    sharedByName: ' (Shared by ' + nextProps.combFilterSectionData.sharedBy.firstName + ' ' + nextProps.combFilterSectionData.sharedBy.lastName + ')'
                })
            } else {
                this.setState({
                    sharedByName: ''
                })
            }
        }
        if (!nextProps.dualFilterId || (nextProps.filter1Data && !nextProps.filter1Data.filterId) || (nextProps.filter2Data && !nextProps.filter2Data.filterId)) {
            /**  dual filter is not selected --> show popup-alert  **/
            this.setState({
                saveCombWithoutFilter: true
            });
        }
        if (this.state.preferences !== nextProps.preferences) {
            this.setState({
                preferences: nextProps.preferences
            }, () => {
                this.calculateCombiFilter();
            })
        }

        if (this.props.saveRandomKey !== nextProps.saveRandomKey) {
            this.saveCombinedFilter();
        }

        if (nextProps.filter1Data && this.state.filter1Data !== nextProps.filter1Data) {

            if (nextProps.filter1Data.deleted) {
                this.setState({
                    isFetchingFilters: false
                });
            } else {
                this.setState({
                    filter1Data: nextProps.filter1Data
                }, function () {
                    this.calculateCombiFilter();
                })
            }
        }

        if (nextProps.filter2Data && this.state.filter2Data !== nextProps.filter2Data) {

            if (nextProps.filter2Data.deleted) {
                this.setState({
                    isFetchingFilters: false
                });
            } else {
                this.setState({
                    filter2Data: nextProps.filter2Data
                }, function () {
                    this.calculateCombiFilter();
                })
            }

        }

        if (typeof nextProps.isPaperGlueWt === 'boolean') {
            this.setState({
                isPaperGlue: nextProps.isPaperGlueWt
            });
        }
        this.assignData(nextProps);
    }
    /**
     *
     * saveCombinedFilter validates the filter and saves it
     *
     * @memberof CombinedFilter
     */
    saveCombinedFilter = () => {
        let _this = this;

        let dataObj = {};

        if (!(this.state.filter1Data.name && this.state.filter2Data.name)) {
            message.error(<Translation labelName="msg_filter_a_or_filter_b_missing" defaultText="Filter A or Filter B data is missing" />)
            return;
        }

        dataObj.dualFilterName = this.state.dualFilterName.replace(/ \((Shared).*/, '') || '';
        dataObj.tipsRod = parseInt(this.state.tipsRod, 10) || '';
        dataObj.comPlugThick = this.state.plugwrapThickness || '';
        dataObj.filterAName = this.state.filter1Data.name;
        dataObj.filterBName = this.state.filter2Data.name;
        dataObj.dualFilterId = this.state.id;
        dataObj.filterAId = this.state.filter1Data.filterId;
        dataObj.filterBId = this.state.filter2Data.filterId;

        this.setState({
            loading: true,
            saveCombWithoutFilter: dataObj.filterAId && dataObj.filterBId ? false : true
        }, function () {
            if (this.state.saveCombWithoutFilter) {
                Modal.error({
                    title: <Translation labelName="msg_can't_save_the_combined_filter" defaultText="Can't Save the Combined Filter" />,
                    content: <Translation labelName="msg_looks_like_filters_cloned" defaultText="Look's like Filters are cloned and not saved, Please save it and try to save the Combined Filter" />,
                    okText: <Translation labelName="btn_ok" defaultText="OK" />,
                    okType: 'info',
                    cancelText: null,
                    onOk() {
                        _this.setState({ saveCombWithoutFilter: false, loading: false });
                    },
                    onCancel() {

                    },
                })
            } else {
                if (this.props.performSave) {
                    this.props.performSave();
                }
                let promiseObj;
                if (this.state.id) {
                    promiseObj = CelaneseAPI.patch(config.API.carbonFilters + '/' + this.state.id, dataObj);
                } else {
                    promiseObj = CelaneseAPI.post(config.API.carbonFilters, dataObj);
                }
                promiseObj.then(resp => {
                    let data = resp.data instanceof Array ? resp.data[0] : resp.data;
                    if (this.state.id) {
                        this.success(utils.getTranslationText('msg_combined_filter_updated', "Combined Filter '${dualFilterName}' is Updated Successfully").replace('${dualFilterName}', this.state.dualFilterName));
                    } else {
                        this.success(utils.getTranslationText('msg_new_combined_filter_created', "New Combined Filter '${dualFilterName}' is created Successfully").replace('${dualFilterName}', this.state.dualFilterName));
                    }
                    this.setState({
                        loading: false,
                        id: data.id
                    });
                    getCarbonFiltersData().then(res => {
                        this.handleFilter();
                        return res;
                    })
                }).catch(() => {
                    this.setState({
                        loading: false
                    });
                    this.error();
                });
            }
        });
    }
    calculateFilter = () => {

    }
    /**
     * handleFilter function is called wheen existing filter is selected. It finds the filter in database and populates
     * the form
     *
     * @memberof CombinedFilter
     */
    handleFilter = () => {
        let data = this.state.combinedFilterData;
        let result = data.find(element => element.id === this.state.id);
        if (result) {
            this.getCigaretteByName(result);
        } else {
            this.setState({
                id: null
            });
            if (this.state.filter1Data && this.state.filter2Data) {
                this.props.performFilterChange({
                    dualFilterName: this.state.dualFilterName,
                    filterAName: this.state.filter1Data.name,
                    filterBName: this.state.filter2Data.name,
                    plugwrapThickness: this.state.plugwrapThickness,
                    tipsRod: this.state.tipsRod,
                    combFilterSectionData: this.state.combFilterSectionData,
                    dualFilterId: null,
                    filterAId: this.state.filter1Data.filterId || null,
                    filterBId: this.state.filter2Data.filterId || null
                });
            }
        }
    }

    getCigaretteByName = (dataObj) => {
        this.setState({
            isFetchingFilters: true
        }, function () {
            if (dataObj && dataObj.dualFilterName) {
                let fetching = true;
                if (dataObj) {

                    if (((this.state.filter1Data && dataObj.filterAName === this.state.filter1Data.name) || dataObj.filterAName === this.state.filterAName)
                        && ((this.state.filter2Data && dataObj.filterBName === this.state.filter2Data.name) || dataObj.filterBName === this.state.filterBName)) {
                        fetching = false;
                    }

                    this.setState({
                        id: dataObj.id,
                        dualFilterName: dataObj.dualFilterName,
                        filterAName: dataObj.filterAName,
                        filterBName: dataObj.filterBName,
                        plugwrapThickness: dataObj.comPlugThick,
                        tipsRod: dataObj.tipsRod,
                        combFilterSectionData: dataObj,
                        isFetchingFilters: fetching
                    });

                    this.props.performFilterChange({
                        filterAName: dataObj.filterAName,
                        filterBName: dataObj.filterBName,
                        dualFilterName: dataObj.dualFilterName,
                        combFilterSectionData: dataObj,
                        dualFilterId: dataObj.id,
                        filterAId: dataObj.filterAId,
                        filterBId: dataObj.filterBId
                    });
                }
            } else {
                this.setState({
                    id: null,
                    dualFilterName: '',
                    filterAName: '',
                    filterBName: '',
                    isFetchingFilters: false
                });

                this.props.performFilterChange({
                    filterAName: '',
                    filterBName: '',
                    dualFilterName: '',
                    combFilterSectionData: {},
                    dualFilterId: null,
                    filterAId: null,
                    filterBId: null
                });
                message.error(<Translation labelName="msg_combined_filter_design_may_deleted" defaultText="Combined Filter design may have been deleted" />);
            }
        });
    }

    getKey() {
        return '' + Math.random() * 1000;
    }


    render() {
        let numberOfTows = this.state.tipsRod;
        let imageHTML = [];
        for (let i = 0; i < numberOfTows; i++) {
            if (i % 2 === 0) {
                imageHTML.push(<li key={this.getKey()}><img alt='filter tip B' src="./images/orange_tip.svg" /><span><Translation labelName="lbl_b" defaultText="B" /></span></li>);
                imageHTML.push(<li key={this.getKey()}><img alt='filter tip A' src="./images/tow.svg" /><span><Translation labelName="lbl_a" defaultText="A" /></span></li>);
            } else {
                imageHTML.push(<li key={this.getKey()}><img alt='filter tip A' src="./images/tow.svg" /><span><Translation labelName="lbl_a" defaultText="A" /></span></li>);
                imageHTML.push(<li key={this.getKey()}><img alt='filter tip B' src="./images/orange_tip.svg" /><span><Translation labelName="lbl_b" defaultText="B" /></span></li>);
            }

        }
        if (numberOfTows % 2 === 0) {
            imageHTML.push(<li key="blank" className='blank'><img alt='cigarette' src="./images/orange_tip.svg" /></li>);
        } else {
            imageHTML.push(<li key="blank" className='blank'><img alt='cigarette' src="./images/tow.svg" /></li>);
        }

        let ListItem = ({ item }) => (
            <Fragment>
                {item.dualFilterName} <i>{" " + item.displayName}</i>
            </Fragment>
        );
        return (
            <div className='filter-wrapper combined-filter'>
                <div>
                    <div className='col-md-3 combined-filter-form'>
                        <div className="col-md-12">
                            <h2><Translation labelName="title_combined_filter" defaultText="Combined Filter" /></h2>
                        </div>
                        <div className='col-md-12'>
                            <label className='combined-label'><Translation labelName="lbl_filter_name" defaultText="Filter Name" /><i>{this.state.sharedByName ? this.state.sharedByName : null}</i></label>
                            <Combobox
                                caseSensitive={false}
                                busy={this.state.isFetchingFilters}
                                value={
                                    {
                                        dualFilterName: this.state.dualFilterName,
                                        id: this.state.id
                                    }
                                }
                                className='dualfilter-combobox'
                                onChange={(obj) => {
                                    let sharedByName = '';

                                    if (typeof obj === 'object' && obj.dualFilterName && obj.isShared) {
                                        sharedByName = obj.displayName;
                                    } else if (typeof obj === 'string' && obj.length > 30) {
                                        return;
                                    }

                                    this.setState({
                                        dualFilterName: obj.dualFilterName || obj,
                                        id: obj.id || null,
                                        sharedByName: sharedByName
                                    }, function () {
                                        this.handleFilter();
                                    })
                                }
                                }
                                data={(this.state.combinedFilterData) ? this.state.combinedFilterData : []}
                                messages={{
                                    emptyList: <Translation labelName="msg_there_r_no_items_list" defaultText="There are no items in this list" />,
                                }}
                                textField='dualFilterName'
                                valueField='id'
                                itemComponent={ListItem}
                            />
                        </div>
                        <div className='col-md-12'>
                            <InputField
                                type='number'
                                label={<Translation labelName="lbl_tips_combined_rod" defaultText="Tips per Combined Rod" />}
                                name='tipsRod'
                                min='0'
                                value={this.state.tipsRod}
                                id='tipsRod'
                                onChange={(event) => this.handleChange(event)}
                                onBlur={(event) => this.handleTipsBlur(event)}
                            />
                        </div>
                        <div className='col-md-12 calculate-filter-wrapper'>
                            <Button
                                className="calculate-link btn btn-primary"
                                type="primary"
                                disabled={this.state.isFetchingFilters}
                                onClick={() => { this.props.performCalculate() }}
                            ><Translation labelName="btn_calculate" defaultText="Calculate" /></Button>
                            <Button
                                className="save-link btn btn-primary"
                                type="primary"
                                disabled={this.state.isFetchingFilters}
                                loading={this.state.loading}
                                onClick={this.saveCombinedFilter}><Translation labelName="btn_save" defaultText="Save" /></Button>
                        </div>
                    </div>
                    <div className='col-md-5 filter-tip-design'>
                        <table className='filter-tip'>
                            <tbody>
                                <tr className='head-row'>
                                    <td>&nbsp;</td>
                                    <td colSpan="2" className='tip-image text-center'>
                                        <ul key={this.getKey()} className='tow-images'>
                                            {imageHTML}
                                        </ul>
                                        <h4><Translation labelName="lbl_combined_filter_rod" defaultText="Combined Filter Rod" /></h4>
                                    </td>
                                    <td colSpan="2" className='tip-image text-center'>
                                        <ul className='tow-images single'>
                                            <li><img alt='filter tip A' src="./images/tow.svg" /><span><Translation labelName="lbl_a" defaultText="A" /></span></li>
                                            <li><img alt='filter tip B' src="./images/orange_tip.svg" /><span><Translation labelName="lbl_b" defaultText="B" /></span></li>
                                        </ul>
                                        <h4><Translation labelName="lbl_combined_tip" defaultText="Combined Tip" /></h4>
                                    </td>
                                </tr>
                                <tr className='top-row'>
                                    <td><label><Translation labelName="lbl_length" defaultText="Length" /> <span><Fragment>(<Translation labelName="units_lbl_mm" defaultText="mm" />)</Fragment></span></label></td>
                                    <td colSpan="2" className='text-center'><span className='head-val'>{parseInt(this.state.totalFilterLength, 10)}</span></td>
                                    <td colSpan="2" className='text-center'><span className='head-val'>{parseInt(this.state.totalTipLength, 10)}</span></td>
                                </tr>
                                <tr>
                                    <th>&nbsp;</th>
                                    <th>Wgt <span className="unit">({this.state.pref.weight[this.state.preferences.weight - 1]})</span></th>
                                    <th>EPD <span className="unit">({this.state.pref.lowpdlim[this.state.preferences.lowpdlim - 1]})</span></th>
                                    <th>Wgt <span className="unit">({this.state.pref.weight[this.state.preferences.weight - 1]})</span></th>
                                    <th>EPD <span className="unit">({this.state.pref.lowpdlim[this.state.preferences.lowpdlim - 1]})</span></th>
                                </tr>
                                <tr>
                                    <td><label>Tow Only</label></td>
                                    <td><span>{this.state.towOnlyFilterWgt}</span></td>
                                    <td><span>{this.state.whiteFilterEPD}</span></td>
                                    <td><span>{this.state.towOnlyTipWgt}</span></td>
                                    <td><span>{this.state.whiteTipEPD}</span></td>
                                </tr>
                                {this.state.rodpgwt > 0 && <tr>
                                    <td><label>Paper+Glue</label></td>
                                    <td><span>{this.state.rodpgwt}</span></td>
                                    <td><span>0.00</span></td>
                                    <td><span>{this.state.tiprodpgwt}</span></td>
                                    <td><span>0.00</span></td>
                                </tr>}
                                {this.state.rodpgwt > 0 && <tr className="white-filter">
                                    <td><label>Dry Filter</label></td>
                                    <td><span>{parseFloat(this.state.drywt).toFixed(2)}</span></td>
                                    <td><span>{parseFloat(this.state.tgtpd).toFixed(2)}</span></td>
                                    <td><span>{this.state.tipdrywt}</span></td>
                                    <td><span>{this.state.tiptgtpd}</span></td>
                                </tr>}
                                {this.state.pz > 0 && <tr>
                                    <td><label>Pz</label></td>
                                    <td><span>{parseFloat(this.state.pzwt).toFixed(2)}</span></td>
                                    <td><span>{parseFloat(this.state.pzpd).toFixed(2)}</span></td>
                                    <td><span>{this.state.tippzwt}</span></td>
                                    <td><span>{this.state.tippzpd}</span></td>
                                </tr>}
                                {this.state.pz > 0 && <tr className="white-filter">
                                    <td><label>Wet Filter</label></td>
                                    <td><span>{parseFloat(this.state.gphtgtwt).toFixed(2)}</span></td>
                                    <td><span>{parseFloat(this.state.gphtgtpd).toFixed(2)}</span></td>
                                    <td><span>{this.state.tipgphtgtwt}</span></td>
                                    <td><span>{this.state.tipgphtgtpd}</span></td>
                                </tr>}
                                {this.state.showCarbon && <tr>
                                    <td><label>Carbon Rod</label></td>
                                    <td><span className="is-carbon">{parseFloat(this.state.carbontgtwt).toFixed(2)}</span></td>
                                    <td><span className="is-carbon">{parseFloat(this.state.carbontgtpd).toFixed(2)}</span></td>
                                    <td><span className="is-carbon">{this.state.tipCarbontgtwt}</span></td>
                                    <td><span className="is-carbon">{this.state.tipCarbontgtpd}</span></td>
                                </tr>}
                                {this.state.showCapsule && <tr>
                                    <td><label>Capsule Rod</label></td>
                                    <td><span className="is-capsule">{parseFloat(this.state.capsuletgtwt).toFixed(2)}</span></td>
                                    <td><span className="is-capsule">{parseFloat(this.state.capsuletgtpd).toFixed(2)}</span></td>
                                    <td><span className="is-capsule">{this.state.tipCapsuletgtwt}</span></td>
                                    <td><span className="is-capsule">{this.state.tipCapsuletgtpd}</span></td>
                                </tr>}
                                {(this.state.showCarbon || this.state.showCapsule) && <tr className="white-filter">
                                    <td><label>Total Filter</label></td>
                                    <td><span>{parseFloat(this.state.filterwt).toFixed(2)}</span></td>
                                    <td><span>{parseFloat(this.state.filterpd).toFixed(2)}</span></td>
                                    <td><span>{this.state.tipfilterwt.toFixed(2)}</span></td>
                                    <td><span>{this.state.tipfilterpd.toFixed(2)}</span></td>
                                </tr>}
                            </tbody>
                        </table>
                    </div>
                    <div className='col-md-4 filter-efficiencies-firmware flush-left'>
                        <div className='tip-paper'>
                            <ul>
                                <li>
                                    <span className="tipping-paper-text"><Translation labelName="lbl_tipping_paper" defaultText="Tipping Paper" /></span>
                                    <img alt='tipping paper' src='./images/tipping-paper-white.png' />
                                    <ul className='tow-images'>
                                        <li><img alt='filter tip A' src="./images/tow.svg" /><span><Translation labelName="lbl_a" defaultText="A" /></span></li>
                                        <li className='orange-tip'><img alt='filter tip B' src="./images/orange_tip.svg" /><span><Translation labelName="lbl_b" defaultText="B" /></span></li>
                                    </ul>
                                </li>
                                <li>
                                    <label><Translation labelName="lbl_combined_tip_circumference" defaultText="Combined Tip Circumference" /></label>
                                    <span>{this.state.combinedTipCirc} <Translation labelName="units_mm" defaultText="mm" /></span>
                                </li>
                                <li>
                                    <label><Translation labelName="lbl_combined_tip_diameter" defaultText="Combined Tip Diameter" /></label>
                                    <span>{this.state.combinedTipDiam} <Translation labelName="units_mm" defaultText="mm" /></span>
                                </li>
                                <li>
                                    <label><Fragment><Translation labelName="lbl_tipping_papar_thickness" defaultText="Tipping paper thickness" /> (<i className="text-lowercase"><Translation labelName="units_mm" defaultText="mm" />)</i></Fragment></label>
                                    <InputField
                                        type='number'
                                        id='plugwrapThickness'
                                        min='0'
                                        buttonIcon='setting'
                                        onButtonClick={this.showPlugwrapModal}
                                        name='plugwrapThickness'
                                        className='filter-wrapper__field plugwrap'
                                        value={this.state.plugwrapThickness}
                                        onChange={(event) => this.handleChange(event)}
                                        onBlur={(event) => this.handleTipsBlur(event)}
                                    />
                                </li>
                                <li>
                                    <label><Translation labelName="lbl_total_tip_circumference" defaultText="Total Tip Circumference" /></label>
                                    <span>{this.state.totalTipCirc} <Translation labelName="units_mm" defaultText="mm" /></span>
                                </li>
                                <li>
                                    <label><Translation labelName="lbl_total_tip_diameter" defaultText="Total Tip Diameter" /></label>
                                    <span>{this.state.totalTipDiam} <Translation labelName="units_mm" defaultText="mm" /></span>
                                </li>
                            </ul>
                        </div>
                        <div className='filter-efficiencies'>
                            <h4><Translation labelName="lbl_removal_efficiencies" defaultText="Removal Efficiencies" /></h4>
                            <ul>
                                <li>
                                    <label><Translation labelName="lbl_smoke" defaultText="Smoke" /></label>
                                    <span>{this.state.smoke} <Translation labelName="units_%" defaultText="(%)" /></span>
                                </li>
                                <li>
                                    <label><Translation labelName="lbl_tar" defaultText="Tar" /></label>
                                    <span>{this.state.tar} <Translation labelName="units_%" defaultText="(%)" /></span>
                                </li>
                                <li>
                                    <label><Translation labelName="lbl_nicotine" defaultText="Nicotine" /></label>
                                    <span>{this.state.nicotine} <Translation labelName="units_%" defaultText="(%)" /></span>
                                </li>
                                {this.state.preferences.kretek ? <li>
                                    <label><Translation labelName="lbl_eugenol" defaultText="Eugenol" /></label>
                                    <span>{this.state.eugenol} <Translation labelName="units_%" defaultText="(%)" /></span>
                                </li> : ''}
                            </ul>
                        </div>
                    </div>
                </div>
                {this.state.isPlugwrapVisible && <Modal
                    visible={this.state.isPlugwrapVisible}
                    footer={null}
                    width='60%'
                    centered
                    style={{ top: 20 }}
                    onCancel={this.handlePlugwrapCancel}>
                    <PlugwrapThickness
                        updatePlugwrapValue={this.updatePlugwrapValue}
                        handlePlugwrapCancel={this.handlePlugwrapCancel}
                        rowSelectionDisable={true}>
                    </PlugwrapThickness>
                </Modal>}
            </div>
        );
    }
}

const mapStateToProps = ({ loggedUserState, filtersState }) => ({
    preferences: loggedUserState.prefData && loggedUserState.prefData.preferences,
    carbonFiltersData: filtersState.carbonFiltersData
});

export default connect(mapStateToProps, null)(CombinedFilter);

CombinedFilter.propTypes = {
    isPaperGlueWt: PropTypes.bool,
    preferences: PropTypes.object,
    dualFilterName: PropTypes.any,
    saveRandomKey: PropTypes.string,
    combFilterSectionData: PropTypes.any,
    filter1Data: PropTypes.object,
    filter2Data: PropTypes.object,
    performCalculate: PropTypes.func,
    performSave: PropTypes.func,
    performFilterChange: PropTypes.func,
    afterCalculate: PropTypes.func,
    random: PropTypes.string,
    carbonFiltersData: PropTypes.array,
    getCarbonFiltersData: PropTypes.func,
    dualFilterId: PropTypes.any
};


// WEBPACK FOOTER //
// ./src/components/FIlters/CombinedFilter/index.js